










    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorDeCurso } from '../curso-controlador';
    import pregunta from './curso-pregunta.vue';
    import final from './curso-final.vue';
    import { Recurso } from '@/__env/lib/Cursos/Recursos';
    import { Wait } from '@/__env/ext';
    import { Pregunta } from '@/__env/lib/Cursos/Preguntas';
    import { Curso } from '@/__env/lib/Cursos';
import { Resultado } from '@/__env/lib/Cursos/Resultado';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            pregunta,
            final,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador(): ControladorDeCurso { return Model; }
        public get Curso(): Curso { return Model.Curso; }
        public get Resultado(): Resultado { return Model.Resultado; }

        public Paso: number = 0;

        mounted()
        {
            console.log( this.Resultado.UltimaPregunta );
            this.Paso = this.Resultado.UltimaPregunta;
        }

        Siguiente()
        {
            this.Paso++;
        }
    }
